import { cookieSubdomain } from '@shared/utils/cookie-sub-domain';

export const AFFILIATE_COOKIE_EXPIRY_DAYS = 90;

export const affiliateCookieOptions: Cookies.CookieAttributes = {
  domain: cookieSubdomain,
  expires: AFFILIATE_COOKIE_EXPIRY_DAYS,
  sameSite: 'Lax', // Allows the cookie to be sent on top-level navigations (e.g. referral link clicks) while protecting against most CSRF attacks; ideal for first-party attribution cookies like PartnerStack
};
